import * as React from 'react';
type IconPreparacionProps = React.SVGProps<SVGSVGElement>;

export const IconPreparacion: React.FC<IconPreparacionProps> = (props) => (
	<svg	 width={20} height={20} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
<path d="M3 5C3 3.89688 3.89688 3 5 3H15C16.1031 3 17 3.89688 17 5V15C17 16.1031 16.1031 17 15 17H5C3.89688 17 3 16.1031 3 15V5ZM5 5V7H7V5H5ZM15 5H9V7H15V5ZM5 9V11H7V9H5ZM15 9H9V11H15V9ZM5 13V15H7V13H5ZM15 13H9V15H15V13Z" />
</svg>



);
export default IconPreparacion;
